import { publisherStore } from '../stores/publisher/publisherStore';
export let SecurityEditorStatus = /*#__PURE__*/function (SecurityEditorStatus) {
  SecurityEditorStatus[SecurityEditorStatus["DifferentSecurityReview"] = 0] = "DifferentSecurityReview";
  SecurityEditorStatus[SecurityEditorStatus["NewSecurityReview"] = 1] = "NewSecurityReview";
  SecurityEditorStatus[SecurityEditorStatus["SameSecurityReview"] = 2] = "SameSecurityReview";
  return SecurityEditorStatus;
}({});
export function getSecurityEditorStatus(newSecurityReviewId, currentSecurityReview) {
  const publisher = publisherStore.getState().publisher;
  if (newSecurityReviewId && newSecurityReviewId !== currentSecurityReview.id) {
    return SecurityEditorStatus.DifferentSecurityReview;
  } else if (!newSecurityReviewId && (newSecurityReviewId !== currentSecurityReview.id || currentSecurityReview.org62AccountId !== publisher.org62AccountId)) {
    return SecurityEditorStatus.NewSecurityReview;
  }
  return SecurityEditorStatus.SameSecurityReview;
}